export default "__VITE_ASSET__eVKWwhmB__"